const STORAGE_KEY = "baysport_cookie_consent";

/**
 * @returns {{ analytics: boolean, version: string, at: string } | null}
 */
export function getCookieConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return parsed;
  } catch {
    return null;
  }
}

export function hasCookieDecision() {
  return getCookieConsent() != null;
}

export function isAnalyticsAllowed() {
  return getCookieConsent()?.analytics === true;
}

export function setCookieConsent({ analytics }) {
  const payload = {
    analytics: !!analytics,
    version: "1",
    at: new Date().toISOString(),
  };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    /* ignore quota */
  }
  window.dispatchEvent(new CustomEvent("baysport:cookie-consent", { detail: payload }));
  return payload;
}
